// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MessagingChatClientes_BulkLookupResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /config/messaging_chat_clientes/bulk_lookup.
 *
 * dados is an ID-keyed map: the key is the normalised identifier (phone digits
 * stripped, or the raw identifier for non-phone types) and the value is a
 * concrete entry Row — `{ linked: false }` or
 * `{ linked: true, cliente_id, cliente_nome, ... }`. The keys are dynamic, but
 * every value shares the MessagingChatClientes_BulkLookupRow shape, so dados
 * projects to `Record<string, MessagingChatClientes_BulkLookupRow>` in TS.
 */
import type { MessagingChatClientes_BulkLookupRow } from './MessagingChatClientes_BulkLookupRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type MessagingChatClientes_BulkLookupResponseDados = Record<string, MessagingChatClientes_BulkLookupRow>;

export type MessagingChatClientes_BulkLookupResponse = ApiResponse<MessagingChatClientes_BulkLookupResponseDados>;

registerResponseContract('MessagingChatClientes_BulkLookupResponse', {})
